// Date 2021-10-16 09:34:49

import mintalMesInventoryMaterialQuantity from "@/store/mintalMes/inventory/MintalMesInventoryMaterialQuantityStore.js";
import mintalMesInventoryQuantityAdjustment from "@/store/mintalMes/inventory/MintalMesInventoryQuantityAdjustmentStore.js";
import mintalMesInventoryInputOutput from "@/store/mintalMes/inventory/MintalMesInventoryInputOutputStore.js";

const genericEntities = [
    'mintalMesInventoryMaterialQuantity',
    'mintalMesInventoryQuantityAdjustment',
    'mintalMesInventoryInputOutput'
]

const entities = {
    mintalMesInventoryMaterialQuantity,
    mintalMesInventoryQuantityAdjustment,
    mintalMesInventoryInputOutput
}

export {genericEntities}

export default entities